import { api, rx } from '../../../api';
import { actions } from './actions';
import { ofType, combineEpics } from 'redux-observable';
import { mergeMap, map, takeUntil } from 'rxjs/operators';
import { actions as sessionActions } from '../session';
import { errorMap } from '../../actions';

const defaultState = {
	typeMap: null,
	mnemonicMap: null,
	pending: false,
	error: null
};

// ---------------------------------------------------------

function reducer(state, action) {
	switch (action.type) {
		case actions.eventTypes.request.type:
			state = {
				...state,
				pending: true,
				error: null
			};
			break;
		case actions.eventTypes.success.type:
			state = {
				...state,
				...action.maps,
				pending: false
			};
			break;
		case actions.eventTypes.fail.type:
			state = {
				...state,
				pending: false,
				error: action.errorMessage
			};
			break;
		case actions.eventTypes.cancel.type:
			state = {
				...state,
				pending: false
			}
			break;
		default:
	}
	return state || defaultState;
};

// ---------------------------------------------------------

function process(eventTypes) {
	const typeMap = {}, mnemonicMap = {};
	eventTypes.forEach(eventType => {
		typeMap[eventType.eventType] = eventType;
		mnemonicMap[eventType.mnemonics] = eventType;
	});
	return { typeMap, mnemonicMap };
}

const loadEpic = (action$) => {
	return action$.pipe(
		ofType(actions.eventTypes.request.type),
		mergeMap(action =>
			rx(api.registry.eventTypes).pipe(
				map(operation => actions.eventTypes.success({ maps: process(operation.response()) })),
				errorMap(actions.eventTypes.fail),
				takeUntil(action$.pipe(ofType(actions.eventTypes.cancel.type)))
			)
		)
	)
}

const watchSessionStartedEpic = (action$) => {
	return action$.pipe(
		ofType(sessionActions.events.started.type),
		map(action => actions.eventTypes.request())
	)
}

const epic = combineEpics(loadEpic, watchSessionStartedEpic);

// ---------------------------------------------------------

export { reducer, epic };
